<template>
  <div class="row">
    <LoadingOverlay
        :activeSyncProps="activeSyncProps"
        :isFullPageProps="false"
    />
    <div class="contents_area">
      <div class="header_container text_left mb100">
        <p class="txt_subtitle_1 mb10">
          Simple pricing
        </p>
        <h3>
          Wonderful experience
        </h3>
      </div>
      <div class="range_container">
        <div class="range_top">
          <PaymentTypeRadio
              :termProps="termProps"
              :selectedTermProps="selectedTermProps"
              class="mt10 mb20"
          />
        </div>
      </div>
      <div class="mt50">
        <ul class="product_list_container">
          <li
              v-for="item in productProps"
              :key="item.seqProduct"
          >
            <div class="product_card_container">
              <div class="top pb20">
                <div class="product_title txt_button_1">{{ item.defaultProductTitle}}</div>
                <div class="txt_subtitle_1 --grey70"> {{ item.defaultProductSubTitle }} </div>
              </div>
              <div class="middle mb20">
                <span class="txt_h5">$</span>
                <span class="txt_h2 line_height_07">{{ item.productAmount }}</span>
                <span class="txt_h5 relative">{{ item.productAmountUnit }}
                  <div
                      v-if="item.productAmount === 0"
                      class="tooltip_ad txt_caption_1 --white --blue70-bg"
                  >
                    Absolutely free!:)
                    <div class="tri">
                    </div>
                  </div>
                  </span>
              </div>
              <div class="txt_body_2 --grey80 text_left mb40">
                {{ item.defaultProductDescription }}
              </div>
              <a @click="goToPaymentInfo(item.productAmount, item.seqProduct)"
                 class="regular-line-button-blue70">
                Get started
              </a>
            </div>
          </li>
        </ul>
      </div>
      </div>
  </div>
</template>
<script>
import PaymentTypeRadio from '@/components/body/payments/comm/paymentTypeRadio';
import LoadingOverlay from '@/components/loadingOverlay';

export default {
  name: 'PlanSetting',
  props: {
    selectedTermProps: Object,
    selectedProductProps: Object,
    termProps: Array,
    productProps: Array,
    activeSyncProps: Boolean
  },
  components: {
    PaymentTypeRadio,
    LoadingOverlay
  },
  methods: {
    goToPaymentInfo(productAmount, seqProduct) {
      if (productAmount === 0) {
        this.$router.go(-1);
      } else {
        this.selectedProductProps.seqProduct = seqProduct;
        this.$router.push('/payments/paymentInfo');
      }
    }
  }
}
</script>